import { CalendarEvent } from '@commenda/types/src/compliance-calendar/compliances/calendar-event';
import { UnifiedFiling } from '@commenda/types/src/compliance-calendar/compliances/unified-filing';
import { ServiceRequestModel } from '@commenda/utils';
import { NextRouter } from 'next/router';

type FilingLike = Pick<
  CalendarEvent | UnifiedFiling,
  'id' | 'source' | 'corporationId' | 'serviceRequestId' | 'salesTaxFilingId'
>;

/**
 * Navigates to the appropriate detail page for a filing/event.
 * Matches the FilingsTable navigation behavior with redirectTo parameter.
 * Can be used for both CalendarEvent and UnifiedFiling types.
 */
export const navigateToFilingDetail = (
  filing: FilingLike,
  router: NextRouter
): void => {
  const redirectTo = encodeURIComponent(router.asPath);
  
  if (filing.source === 'SALES_TAX_FILING') {
    if (!filing.salesTaxFilingId) return;
    const base = ServiceRequestModel.getCompanyFilingLink(
      String(filing.salesTaxFilingId),
      filing.corporationId
    );
    router.push(`${base}?redirectTo=${redirectTo}`);
  } else if (filing.serviceRequestId) {
    router.push(
      `/service-request/${filing.serviceRequestId}?redirectTo=${redirectTo}`
    );
  } else {
    router.push(
      `/compliance-monitor/compliance/${filing.id}?redirectTo=${redirectTo}`
    );
  }
};

// Alias for backward compatibility and clearer naming in calendar context
export const navigateToEventDetail = navigateToFilingDetail;